"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeoutPromise = void 0;
class TimeoutPromise extends Promise {
    constructor(timeout, callback) {
        const haveTimeout = typeof timeout === "number";
        const init = haveTimeout ? callback : timeout;
        super((resolve, reject) => {
            if (haveTimeout) {
                const timer = setTimeout(() => {
                    reject(new Error(`Promise timed out after ${timeout}ms`));
                }, timeout);
                init((value) => {
                    clearTimeout(timer);
                    resolve(value);
                }, (error) => {
                    clearTimeout(timer);
                    reject(error);
                });
            }
            else {
                init(resolve, reject);
            }
        });
    }
    static resolveWithTimeout(timeout, x) {
        if (!x || typeof x.then !== "function") {
            return this.resolve(x);
        }
        return new this(timeout, x.then.bind(x));
    }
}
exports.TimeoutPromise = TimeoutPromise;
//# sourceMappingURL=TimeoutPromise.js.map